export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-teal-900 text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-6">
              <img 
                src="https://static.readdy.ai/image/1122cb27b252d075a2451a67773799cc/7670fadaa3ac02a0b489708526bd4cce.jpeg"
                alt="WeBus Transporte Málaga"
                className="h-12 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Servicio premium de transporte en microbús para grupos en Málaga y Costa del Sol. 
              Flota exclusiva Mercedes-Benz Sprinter.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-teal-500 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-teal-500 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-teal-500 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-teal-500 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6">Servicios</h4>
            <ul className="space-y-3">
              <li>
                <a href="#servicios" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Traslado Aeropuerto
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Servicio Ejecutivo
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Tours Privados
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Traslados Grupales
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Eventos Especiales
                </a>
              </li>
            </ul>
          </div>

          {/* Information */}
          <div>
            <h4 className="text-lg font-bold mb-6">Información</h4>
            <ul className="space-y-3">
              <li>
                <a href="#inicio" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Inicio
                </a>
              </li>
              <li>
                <a href="#flota" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Nuestra Flota
                </a>
              </li>
              <li>
                <a href="#testimonios" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Testimonios
                </a>
              </li>
              <li>
                <a href="#contacto" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Contacto
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Política de Privacidad
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-lg font-bold mb-6">Newsletter</h4>
            <p className="text-gray-400 mb-4 text-sm">
              Suscríbete para recibir ofertas especiales y noticias
            </p>
            <div className="flex">
              <input 
                type="email" 
                placeholder="Tu email"
                className="flex-1 px-4 py-2 bg-slate-800 border border-slate-700 rounded-l-lg focus:outline-none focus:border-teal-500 text-white placeholder-gray-400"
              />
              <button className="bg-teal-600 hover:bg-teal-700 px-4 py-2 rounded-r-lg transition-colors">
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-2">
              Respetamos tu privacidad. Sin spam.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2024 WeBus Transporte Málaga. Todos los derechos reservados.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                Política de Privacidad
              </a>
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                Términos y Condiciones
              </a>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}